<template>
  <div class="choose-campus">
    <Select
      v-model="schBranchId"
      filterable
      :disabled="disabled"
      :placeholder="placeholder"
      @on-change="handleChange"
    >
      <Option
        v-for="(item, index) in schBranchIdList"
        :key="index"
        :value="item.branchId"
        >{{ item.branchName }}{{ item.name }}</Option
      >
    </Select>
  </div>
</template>

<script>
import courseCenterApi from '@/request/courseCenter/index.js';
import { mapState } from 'vuex';

export default {
  name: 'choose-campus',
  props: {
    orgId: {
      type: [String, Number],
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择校区'
    },
    //是否有全部校区
    isallCampus: {
      type: Boolean,
      default: false
    },
    // 学年和学期
    yearTermCode: {
      typeof: String
    }
  },
  computed: { ...mapState(['userInfo']) },
  data() {
    return {
      schBranchIdList: [], //校区列表
      schBranchId: '', //校区id
      portOrg: Number(localStorage.getItem('portOrg'))
    };
  },
  watch: {
    orgId:{
      handler(newval,oldVal){
        if (newval != oldVal && newval && this.portOrg !== 2) {
          this.getgoodAreaListFun(newval);
        }
      },
      immediate:true
    },
  },
  created() {
    if (this.portOrg === 2) {
      this.getgoodAreaListFun(this.userInfo.orgId);
    }
  },
  methods: {
    getResult() {
      return this.schBranchId;
    },
    handleClear() {
      this.schBranchId = '';
    },
    // 搜索框 校区列表
    async getgoodAreaListFun(newval) {
      const params = {
        orgId: newval
      };

      const res = await courseCenterApi.getgoodAreaList(params);
      if (res.status === 200) {
        const arr = this.isallCampus
          ? [{ branchId: -1, branchName: '全部校区' }]
          : [];
        this.schBranchIdList = [
          ...arr,
          ...res.message.map(item => {
            return { branchId: item.branchId, branchName: item.branchName };
          })
        ];
        if (this.isallCampus) {
          this.schBranchId = -1;
          if (res.message.length == 1) {
            this.schBranchId = res.message[0]['branchId'];
          }
        } else {
          this.schBranchId =
            res.message.length > 0 ? res.message[0]['branchId'] : '';
        }
        this.$emit('on-change', this.schBranchId);
      }
    },
    // 校区选择
    handleChange(value) {
      this.$emit('on-change', value);
    }
  }
};
</script>

<style></style>
